/**
 * Useful keycodes
 *
 * @package stylr
 */
export const keycode = {
    down: 40,
    enter: 13,
    esc: 27,
    home: 36,
    left: 37,
    pagedown: 34,
    pageup: 33,
    right: 39,
    space: 32,
    tab: 9,
    up: 38
};
